import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import InputWithButton from '../Common/InputWithButton/InputWithButton';

const SignInForm = ({ showPasswordField, username, password, onSubmitUsername, onSubmitCreds, onChange, isFormValid }) => {
    const valid = (!isFormValid) ? "was-validated" :  "";
    const formClass = "form-signin " + valid;

    return (
        <form name="signin-form" onSubmit={showPasswordField ? onSubmitCreds : onSubmitUsername} className={formClass} noValidate>
            { 
                /** 
                 * Do not set the username field to focused if the username is not blank.  Always setting
                 * the focus causes a loop calling the onBlur function, which would hammer the API
                 * with check username requests.
                 */
            }

            <div>

                <div>
                    <div>
                        <InputWithButton
                            name="username"
                            type="text"
                            placeholder="Enter your username"
                            value={username || ''}
                            onChange={onChange}
                            onBlur={onSubmitUsername}
                            errorMessage="Please enter a username"
                            isFocused={!showPasswordField}
                            isRequired={true}
                            showButton={!showPasswordField}
                            onButtonClick={onSubmitUsername} />
                    </div>
                    { showPasswordField &&
                        <div>
                            <InputWithButton
                                name="password"
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={onChange}
                                errorMessage="Please enter a password"
                                isFocused={showPasswordField}
                                isRequired={true}
                                showButton={true} 
                                onButtonClick={onSubmitCreds} />
                        </div>                    
                    }
                </div>


                
            </div>

            <div className="forgot-things">
                <div>
                    { showPasswordField ?
                        <NavLink className="nav-link" to="/Forgot-Password">Forgot Password?</NavLink>
                        :
                        <NavLink className="nav-link" to="/Forgot-Username">Forgot Username?</NavLink>
                    }
                </div>
            </div>

        </form>
    );
};

SignInForm.propTypes = {
    showPasswordField: PropTypes.bool.isRequired,
    username: PropTypes.string,
    password: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmitUsername: PropTypes.func.isRequired,
    onSubmitCreds: PropTypes.func.isRequired,
    isFormValid: PropTypes.bool.isRequired
};

export default SignInForm;
